/* =========================================
   MUBLIG Wishlist
   Datei: assets/mublig-wishlist.js

   Funktionen:
   - lokale Wunschliste per localStorage
   - Gast-/Kunden-Speicherung
   - Gastliste bei Login übernehmen
   - Header-Zähler aktualisieren
   - Produktseiten- und Produktkarten-Herz steuern
   - Wunschliste-Seite rendern
   - Live-Preis / Live-Verfügbarkeit über Shopify Product JSON
   - individuelle Wunschliste teilen per ?wl=
   - einzelne Artikel / alle Artikel in Warenkorb legen
   ========================================= */

(function () {
  if (window.__mubligWishlistLoaded) return;
  window.__mubligWishlistLoaded = true;

  var STORAGE_GUEST_KEY = 'mublig_wishlist_guest';
  var STORAGE_CUSTOMER_PREFIX = 'mublig_wishlist_customer_';
  var liveWishlistRefreshRunning = false;

  var CART_ICON_HTML =
    '<svg class="mublig-wishlist-icon" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M6.2 6.5h14.1l-1.6 8.2H8.1L6.2 6.5Z"></path>' +
      '<path d="M6.2 6.5 5.5 3.8H3"></path>' +
      '<path d="M9.2 20.2a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8Z"></path>' +
      '<path d="M17.6 20.2a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8Z"></path>' +
    '</svg>';

  var HEART_ICON_HTML =
    '<svg class="mublig-wishlist-icon" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M20.8 4.7a5.2 5.2 0 0 0-7.4 0L12 6.1l-1.4-1.4a5.2 5.2 0 0 0-7.4 7.4L12 20.6l8.8-8.5a5.2 5.2 0 0 0 0-7.4Z"></path>' +
    '</svg>';

  var TRASH_ICON_HTML =
    '<svg class="mublig-wishlist-icon" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M4 7h16"></path>' +
      '<path d="M10 11v6"></path>' +
      '<path d="M14 11v6"></path>' +
      '<path d="M6 7l1 14h10l1-14"></path>' +
      '<path d="M9 7V4h6v3"></path>' +
    '</svg>';

  function getCustomerId() {
    return window.MUBLIG_CUSTOMER_ID || null;
  }

  function getStorageKey() {
    var customerId = getCustomerId();
    return customerId ? STORAGE_CUSTOMER_PREFIX + customerId : STORAGE_GUEST_KEY;
  }

  function safeParse(value) {
    try {
      return JSON.parse(value || '[]');
    } catch (error) {
      return [];
    }
  }

  function getListByKey(key) {
    try {
      return safeParse(window.localStorage.getItem(key));
    } catch (error) {
      return [];
    }
  }

  function saveListByKey(key, list) {
    try {
      window.localStorage.setItem(key, JSON.stringify(list || []));
    } catch (error) {
      console.warn('MUBLIG Wishlist: localStorage konnte nicht gespeichert werden.', error);
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function extractHandleFromUrl(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match && match[1] ? decodeURIComponent(match[1]) : '';
  }

  function normalizeItem(item) {
    if (!item) return null;

    var handle = item.handle || item.productHandle || extractHandleFromUrl(item.url) || '';
    var productId = item.productId || item.id || '';
    var variantId = item.variantId || '';

    if (!handle && !productId && !variantId) return null;

    return {
      handle: String(handle || ''),
      productId: String(productId || ''),
      variantId: String(variantId || ''),
      title: String(item.title || ''),
      url: String(item.url || ''),
      image: String(item.image || ''),
      price: String(item.price || ''),
      available: item.available === false ? false : true,
      addedAt: item.addedAt || new Date().toISOString()
    };
  }

  function getItemKey(item) {
    if (!item) return '';
    return item.variantId || item.productId || item.handle || item.url || '';
  }

  function uniqueList(list) {
    var seen = {};
    var result = [];

    (list || []).forEach(function (rawItem) {
      var item = normalizeItem(rawItem);
      var key = getItemKey(item);

      if (!item || !key || seen[key]) return;

      seen[key] = true;
      result.push(item);
    });

    return result;
  }

  function getList() {
    return uniqueList(getListByKey(getStorageKey()));
  }

  function saveList(list) {
    saveListByKey(getStorageKey(), uniqueList(list));
    updateAll();
  }

  function mergeGuestIntoCustomerIfNeeded() {
    var customerId = getCustomerId();

    if (!customerId) return;

    var customerKey = getStorageKey();
    var guestList = getListByKey(STORAGE_GUEST_KEY);

    if (!guestList.length) return;

    var customerList = getListByKey(customerKey);
    var merged = uniqueList(customerList.concat(guestList));

    saveListByKey(customerKey, merged);

    try {
      window.localStorage.removeItem(STORAGE_GUEST_KEY);
    } catch (error) {
      console.warn('MUBLIG Wishlist: Gastliste konnte nicht entfernt werden.', error);
    }
  }

  function hasItem(itemOrKey, optionalList) {
    var list = optionalList || getList();
    var key = typeof itemOrKey === 'string'
      ? itemOrKey
      : getItemKey(normalizeItem(itemOrKey));

    if (!key) return false;

    return list.some(function (item) {
      return getItemKey(item) === key;
    });
  }

  function addItem(item) {
    var normalized = normalizeItem(item);

    if (!normalized) return false;

    var list = getList();
    var key = getItemKey(normalized);

    if (hasItem(key, list)) {
      updateAll();
      return false;
    }

    list.unshift(normalized);
    saveList(list);

    return true;
  }

  function removeItem(itemOrKey) {
    var key = typeof itemOrKey === 'string'
      ? itemOrKey
      : getItemKey(normalizeItem(itemOrKey));

    if (!key) return false;

    var list = getList().filter(function (item) {
      return getItemKey(item) !== key;
    });

    saveList(list);

    return true;
  }

  function toggleItem(item) {
    var normalized = normalizeItem(item);

    if (!normalized) return false;

    var key = getItemKey(normalized);

    if (hasItem(key)) {
      removeItem(key);
      return false;
    }

    addItem(normalized);
    return true;
  }

  function countItems() {
    return getList().length;
  }

  function parseWishlistPrice(value) {
    var raw = String(value || '')
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');

    var number = Number(raw);

    return Number.isNaN(number) ? 0 : number;
  }

  function formatWishlistMoney(value) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(value || 0);
  }

  function formatCartMoneyFromCents(value) {
    var amount = Number(value || 0) / 100;

    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  }

  function getWishlistTotal(list) {
    return (list || []).reduce(function (sum, item) {
      return sum + parseWishlistPrice(item.price);
    }, 0);
  }

  function isValidVariantId(variantId) {
    return (
      !!variantId &&
      variantId !== 'undefined' &&
      variantId !== 'null' &&
      !Number.isNaN(Number(variantId))
    );
  }

  function getItemFromButton(button) {
    return normalizeItem({
      handle: button.dataset.productHandle || '',
      productId: button.dataset.productId || '',
      variantId: button.dataset.variantId || '',
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || '',
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || '',
      available: button.dataset.productAvailable === 'false' ? false : true
    });
  }

  function getProductJsonUrl(handle) {
    return '/products/' + encodeURIComponent(handle) + '.js';
  }

  function fetchProductByHandle(handle) {
    if (!handle) {
      return Promise.reject(new Error('Missing product handle'));
    }

    return fetch(getProductJsonUrl(handle), {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Product fetch failed');
      }

      return response.json();
    });
  }

  function findVariant(product, variantId) {
    var variants = product && product.variants ? product.variants : [];

    if (!variants.length) return null;

    if (variantId) {
      var matchingVariant = variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      });

      if (matchingVariant) return matchingVariant;
    }

    var availableVariant = variants.find(function (variant) {
      return variant.available;
    });

    return availableVariant || variants[0];
  }

  function getProductImage(product, variant, fallbackImage) {
    if (variant && variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }

    if (product && product.featured_image) {
      return product.featured_image;
    }

    if (product && product.images && product.images.length) {
      return product.images[0];
    }

    return fallbackImage || '';
  }

  function buildLiveWishlistItem(oldItem, product) {
    var variant = findVariant(product, oldItem.variantId);

    if (!variant) return oldItem;

    return normalizeItem({
      handle: product.handle || oldItem.handle,
      productId: product.id || oldItem.productId,
      variantId: variant.id || oldItem.variantId,
      title: product.title || oldItem.title,
      url: '/products/' + (product.handle || oldItem.handle) + '?variant=' + variant.id,
      image: getProductImage(product, variant, oldItem.image),
      price: formatCartMoneyFromCents(variant.price || product.price || 0),
      available: variant.available === true,
      addedAt: oldItem.addedAt
    });
  }

  function refreshLiveWishlistItems(list) {
    var wishlist = list || getList();
    var container = document.getElementById('MubligWishlistPage');

    if (!container || liveWishlistRefreshRunning || !wishlist.length) {
      return Promise.resolve(wishlist);
    }

    liveWishlistRefreshRunning = true;

    return Promise.all(
      wishlist.map(function (item) {
        if (!item.handle) return Promise.resolve(item);

        return fetchProductByHandle(item.handle)
          .then(function (product) {
            return buildLiveWishlistItem(item, product);
          })
          .catch(function () {
            return item;
          });
      })
    )
      .then(function (updatedList) {
        var cleanList = uniqueList(updatedList);

        saveListByKey(getStorageKey(), cleanList);

        updateHeaderCount(cleanList);
        updateButtons(cleanList);
        updateWishlistPage(cleanList);

        document.dispatchEvent(new CustomEvent('mublig:wishlist:live-updated', {
          detail: {
            count: cleanList.length,
            items: cleanList
          }
        }));

        return cleanList;
      })
      .catch(function () {
        return wishlist;
      })
      .then(function (result) {
        liveWishlistRefreshRunning = false;
        return result;
      });
  }

  function encodeWishlistSharePayload(list) {
    var payload = (list || [])
      .filter(function (item) {
        return item.handle;
      })
      .map(function (item) {
        return {
          h: item.handle,
          v: item.variantId || ''
        };
      });

    try {
      return window.btoa(JSON.stringify(payload));
    } catch (error) {
      return '';
    }
  }

  function decodeWishlistSharePayload(value) {
    if (!value) return [];

    try {
      var decoded = JSON.parse(window.atob(value));

      if (!Array.isArray(decoded)) return [];

      return decoded
        .filter(function (item) {
          return item && item.h;
        })
        .map(function (item) {
          return {
            handle: String(item.h || ''),
            variantId: String(item.v || '')
          };
        });
    } catch (error) {
      return [];
    }
  }

  function buildWishlistShareUrl() {
    return window.location.origin + window.location.pathname;
  }
  function createServerWishlistShare() {
  var items = getList()
    .filter(function (item) {
      return item.handle;
    })
    .map(function (item) {
      return {
        handle: item.handle,
        variantId: item.variantId || ''
      };
    });

  if (!items.length) {
    return Promise.reject(new Error('EMPTY_WISHLIST'));
  }

  return fetch('/apps/mublig-wishlist/share', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      items: items
    })
  })
    .then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || !data.ok) {
          throw new Error(data.error || 'SHARE_FAILED');
        }

        return data;
      });
    });
  }

  function loadServerWishlistShare(token) {
    return fetch('/apps/mublig-wishlist/shared?token=' + encodeURIComponent(token), {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || !data.ok) {
            throw new Error(data.error || 'SHARED_LOAD_FAILED');
          }

          return data;
        });
      });
  }

  function importSharedWishlistFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var sharedValue = params.get('wl');

    if (!sharedValue) {
      return Promise.resolve(false);
    }

    /* Alte lange Base64-Links weiterhin unterstützen */
    if (sharedValue.indexOf('wl-') !== 0) {
      var oldSharedItems = decodeWishlistSharePayload(sharedValue);

      if (!oldSharedItems.length) {
        return Promise.resolve(false);
      }

      return Promise.all(
        oldSharedItems.map(function (sharedItem) {
          return fetchProductByHandle(sharedItem.handle)
            .then(function (product) {
              return buildLiveWishlistItem(
                {
                  handle: sharedItem.handle,
                  variantId: sharedItem.variantId,
                  addedAt: new Date().toISOString()
                },
                product
              );
            })
            .catch(function () {
              return null;
            });
        })
      ).then(function (items) {
        var importedItems = items.filter(Boolean);

        if (!importedItems.length) return false;

        var mergedList = uniqueList(importedItems.concat(getList()));

        saveListByKey(getStorageKey(), mergedList);

        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, document.title, window.location.pathname);
        }

        return true;
      });
    }

    /* Neue kurze Worker-Links */
    return loadServerWishlistShare(sharedValue)
      .then(function (data) {
        var sharedItems = Array.isArray(data.items) ? data.items : [];

        if (!sharedItems.length) return false;

        return Promise.all(
          sharedItems.map(function (sharedItem) {
            return fetchProductByHandle(sharedItem.handle)
              .then(function (product) {
                return buildLiveWishlistItem(
                  {
                    handle: sharedItem.handle,
                    variantId: sharedItem.variantId,
                    addedAt: new Date().toISOString()
                  },
                  product
                );
              })
              .catch(function () {
                return null;
              });
          })
        );
      })
      .then(function (items) {
        if (!items) return false;

        var importedItems = items.filter(Boolean);

        if (!importedItems.length) return false;

        var mergedList = uniqueList(importedItems.concat(getList()));

        saveListByKey(getStorageKey(), mergedList);

        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, document.title, window.location.pathname);
        }

        return true;
      })
      .catch(function (error) {
        console.warn('MUBLIG Wishlist: Geteilte Wunschliste konnte nicht geladen werden.', error);
        return false;
      });
  }

  function updateHeaderCount(list) {
    var count = (list || getList()).length;

    document.querySelectorAll('[data-mublig-wishlist-count]').forEach(function (element) {
      element.textContent = String(count);
    });

    document.querySelectorAll(
      '.mublig-header-action[href="/pages/wunschliste"], .mublig-header-action[href*="/pages/wunschliste"]'
    ).forEach(function (element) {
      element.setAttribute('data-count', String(count));
      element.classList.toggle('has-count', count > 0);
    });
  }

  function updateButtons(list) {
    var wishlist = list || getList();

    document.querySelectorAll('[data-mublig-wishlist-button]').forEach(function (button) {
      var item = getItemFromButton(button);
      var active = hasItem(item, wishlist);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        active ? 'Von Wunschliste entfernen' : 'Zur Wunschliste hinzufügen'
      );

      var textElement = button.querySelector('[data-mublig-wishlist-label]');
      if (textElement) {
        textElement.textContent = active ? 'Gespeichert' : 'Wunschliste';
      }
    });
  }

  function renderEmptyPage() {
    return (
      '<section class="mublig-wishlist-shell">' +
        '<div class="mublig-wishlist-empty">' +
          '<div class="mublig-wishlist-empty__icon">♡</div>' +
          '<h1>Deine Wunschliste ist leer</h1>' +
          '<p>Speichere Produkte mit dem Herz-Symbol und finde sie später hier wieder.</p>' +
          '<a href="/collections/all">Produkte entdecken</a>' +
        '</div>' +
      '</section>'
    );
  }

  function renderHero(list) {
    return (
      '<div class="mublig-wishlist-hero">' +
        '<div>' +
          '<div class="mublig-wishlist-title-row">' +
            '<h1>Deine Wunschliste</h1>' +
            '<span>' + list.length + ' Artikel</span>' +
          '</div>' +
          '<p>Deine Lieblingsstücke auf einen Blick. Preise inkl. MwSt. und zzgl. Versand.</p>' +
        '</div>' +

        '<div class="mublig-wishlist-actions-top">' +
          '<button type="button" class="mublig-wishlist-action" data-mublig-wishlist-share>Liste teilen</button>' +
          '<button type="button" class="mublig-wishlist-action is-primary" data-mublig-wishlist-add-all>Alle in den Warenkorb</button>' +
        '</div>' +
      '</div>'
    );
  }

  function renderSummary(list, total) {
    return (
      '<div class="mublig-wishlist-summary">' +

        '<div class="mublig-wishlist-summary__item">' +
          '<span class="mublig-wishlist-summary__icon">♡</span>' +
          '<div>' +
            '<small>Gespeicherte Artikel</small>' +
            '<strong>' + list.length + '</strong>' +
            '<em>Artikel</em>' +
          '</div>' +
        '</div>' +

        '<div class="mublig-wishlist-summary__item">' +
          '<span class="mublig-wishlist-summary__icon">⌑</span>' +
          '<div>' +
            '<small>Gesamtwert</small>' +
            '<strong>' + formatWishlistMoney(total) + '</strong>' +
            '<em>inkl. MwSt.</em>' +
          '</div>' +
        '</div>' +

        '<div class="mublig-wishlist-summary__item">' +
          '<span class="mublig-wishlist-summary__icon">▱</span>' +
          '<div>' +
            '<small>Versand</small>' +
            '<strong>Nach Warenkorb</strong>' +
            '<em>Vorteile je nach Produktgruppe</em>'+
          '</div>' +
        '</div>' +

        '<div class="mublig-wishlist-summary__item">' +
          '<span class="mublig-wishlist-summary__icon">□</span>' +
          '<div>' +
            '<small>Gültig bis</small>' +
            '<strong>Unbegrenzt</strong>' +
            '<em>Solange verfügbar</em>' +
          '</div>' +
        '</div>' +

      '</div>'
    );
  }

  function renderToolbar() {
    return '';
  }

  function renderWishlistCard(item) {
    var key = getItemKey(item);
    var canAddToCart = isValidVariantId(item.variantId) && item.available !== false;
    var title = item.title || 'Produkt ansehen';
    var url = item.url || '#';
    var stockClass = item.available === false ? ' is-sold-out' : '';
    var stockText = item.available === false ? 'Nicht verfügbar' : 'Auf Lager';

    return (
      '<article class="mublig-wishlist-card" data-wishlist-key="' + escapeHtml(key) + '">' +

        '<button type="button" class="mublig-wishlist-card__heart" data-mublig-wishlist-remove="' + escapeHtml(key) + '" aria-label="Von Wunschliste entfernen">' +
          HEART_ICON_HTML +
        '</button>' +

        '<a class="mublig-wishlist-card__image" href="' + escapeHtml(url) + '">' +
          (
            item.image
              ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(title) + '" loading="lazy">'
              : '<span></span>'
          ) +
        '</a>' +

        '<div class="mublig-wishlist-card__content">' +

          '<a class="mublig-wishlist-card__title" href="' + escapeHtml(url) + '">' +
            escapeHtml(title) +
          '</a>' +

          '<div class="mublig-wishlist-card__meta-row">' +
            (item.price ? '<strong class="mublig-wishlist-card__price">' + escapeHtml(item.price) + '</strong>' : '<span></span>') +
            '<div class="mublig-wishlist-card__stock' + stockClass + '">' +
              '<span></span> ' + stockText +
            '</div>' +
          '</div>' +

          '<div class="mublig-wishlist-card__actions">' +
            (
              canAddToCart
                ? '<button type="button" class="mublig-wishlist-card__cart" data-mublig-wishlist-add-cart data-variant-id="' + escapeHtml(item.variantId) + '" aria-label="In den Warenkorb">' + CART_ICON_HTML + '</button>'
                : '<a class="mublig-wishlist-card__cart is-unavailable" href="' + escapeHtml(url) + '" aria-label="Zum Produkt">' + CART_ICON_HTML + '</a>'
            ) +
            '<button type="button" class="mublig-wishlist-card__remove" data-mublig-wishlist-remove="' + escapeHtml(key) + '">' +
              TRASH_ICON_HTML +
              '<span>Entfernen</span>' +
            '</button>' +
          '</div>' +

        '</div>' +
      '</article>'
    );
  }

  function renderWishlistGrid(list) {
    return (
      '<div class="mublig-wishlist-grid">' +
        list.map(renderWishlistCard).join('') +
      '</div>'
    );
  }

  function renderWishlistNote() {
    return (
      '<div class="mublig-wishlist-note">' +
        '<span>♡</span>' +
        'Preise und Verfügbarkeit werden beim Öffnen aktualisiert.'
      + '</div>'
    );
  }

  function updateWishlistPage(list) {
    var container = document.getElementById('MubligWishlistPage');

    if (!container) return;

    var wishlist = list || getList();
    var total = getWishlistTotal(wishlist);

    if (!wishlist.length) {
      container.innerHTML = renderEmptyPage();
      return;
    }

    container.innerHTML =
      '<section class="mublig-wishlist-shell">' +
        renderHero(wishlist) +
        renderSummary(wishlist, total) +
        renderToolbar(wishlist) +
        renderWishlistGrid(wishlist) +
        renderWishlistNote() +
      '</section>';
  }

  function addVariantToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantity || 1
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart add failed');
      }

      return response.json();
    });
  }

  function addAllToCart(items) {
    var validItems = (items || [])
      .filter(function (item) {
        return isValidVariantId(item.variantId) && item.available !== false;
      })
      .map(function (item) {
        return {
          id: Number(item.variantId),
          quantity: 1
        };
      });

    if (!validItems.length) {
      return Promise.reject(new Error('No valid variants'));
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: validItems
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart add all failed');
      }

      return response.json();
    });
  }

  function updateCartDisplays(cart) {
    if (!cart) return;

    var count = Number(cart.item_count || 0);
    var total = formatCartMoneyFromCents(cart.total_price || 0);

    document.querySelectorAll('.mublig-header-action--cart em').forEach(function (element) {
      element.textContent = String(count);
    });

    document.querySelectorAll('.mublig-header-action--cart > span:not(.mublig-header-action__icon-wrap) small').forEach(function (element) {
      element.textContent = total;
    });

    document.querySelectorAll('.mublig-mobile-app-header__cart-count').forEach(function (element) {
      element.textContent = String(count);

      if (count > 0) {
        element.hidden = false;
        element.removeAttribute('hidden');
      } else {
        element.hidden = true;
        element.setAttribute('hidden', '');
      }
    });

    document.querySelectorAll('[data-mublig-cart-count]').forEach(function (element) {
      element.textContent = String(count);
    });

    document.querySelectorAll('[data-mublig-cart-total]').forEach(function (element) {
      element.textContent = total;
    });

    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:not(.visually-hidden)').forEach(function (element) {
      element.textContent = String(count);
    });

    document.body.classList.toggle('mublig-cart-has-items', count > 0);
  }

  function refreshCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart refresh failed');
        }

        return response.json();
      })
      .then(function (cart) {
        updateCartDisplays(cart);

        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: {
            cart: cart
          }
        }));

        document.dispatchEvent(new CustomEvent('mublig:cart:updated', {
          detail: {
            cart: cart
          }
        }));

        return cart;
      })
      .catch(function (error) {
        console.warn('MUBLIG Wishlist: Warenkorb konnte nicht aktualisiert werden.', error);

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('mublig:cart:updated'));
      });
  }

  function setTemporaryButtonState(button, text, duration, resetCallback) {
    button.textContent = text;

    window.setTimeout(function () {
      resetCallback();
    }, duration || 1300);
  }

  function handleWishlistButton(button) {
    var item = getItemFromButton(button);
    toggleItem(item);
  }

  function handleAddCartButton(button) {
    var variantId = button.dataset.variantId;

    if (!isValidVariantId(variantId)) return;

    button.disabled = true;
    button.classList.add('is-loading');
    button.innerHTML = '…';

    addVariantToCart(variantId, 1)
      .then(function () {
        button.classList.remove('is-loading');
        button.classList.add('is-success');
        button.innerHTML = '✓';

        refreshCart();

        window.setTimeout(function () {
          button.disabled = false;
          button.classList.remove('is-success');
          button.innerHTML = CART_ICON_HTML;
        }, 1100);
      })
      .catch(function () {
        button.classList.remove('is-loading');
        button.classList.add('is-error');
        button.innerHTML = '!';

        window.setTimeout(function () {
          button.disabled = false;
          button.classList.remove('is-error');
          button.innerHTML = CART_ICON_HTML;
        }, 1300);
      });
  }

  function handleAddAllButton(button) {
    var list = getList();
    var originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Wird aktualisiert...';

    refreshLiveWishlistItems(list)
      .then(function (liveList) {
        button.textContent = 'Wird hinzugefügt...';
        return addAllToCart(liveList);
      })
      .then(function () {
        button.textContent = 'Hinzugefügt';
        refreshCart();

        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText || 'Alle in den Warenkorb';
        }, 1300);
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Fehler';

        window.setTimeout(function () {
          button.textContent = originalText || 'Alle in den Warenkorb';
        }, 1300);
      });
  }

  function handleShareButton(button) {
    var originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Link wird erstellt...';

    createServerWishlistShare()
      .then(function (data) {
        var shareUrl = data.url;
        var shareTitle = 'Meine MUBLIG Wunschliste';
        var shareMessage =
          'Schau dir meine Wunschliste auf MUBLIG an:\n' +
          shareUrl;

        if (navigator.share) {
          return navigator.share({
            title: shareTitle,
            text: shareMessage
          }).then(function () {
            return 'Geteilt';
          });
        }

        if (!navigator.clipboard) {
          throw new Error('CLIPBOARD_NOT_AVAILABLE');
        }

        return navigator.clipboard.writeText(shareMessage).then(function () {
          return 'Listenlink kopiert';
        });
      })
      .then(function (text) {
        setTemporaryButtonState(button, text || 'Geteilt', 1500, function () {
          button.disabled = false;
          button.textContent = originalText || 'Liste teilen';
        });
      })
      .catch(function (error) {
        console.warn('MUBLIG Wishlist: Teilen fehlgeschlagen.', error);

        setTemporaryButtonState(button, 'Fehler', 1500, function () {
          button.disabled = false;
          button.textContent = originalText || 'Liste teilen';
        });
      });
  }

  function bindClicks() {
    document.addEventListener('click', function (event) {
      var wishlistButton = event.target.closest('[data-mublig-wishlist-button]');
      if (wishlistButton) {
        event.preventDefault();
        handleWishlistButton(wishlistButton);
        return;
      }

      var addCartButton = event.target.closest('[data-mublig-wishlist-add-cart]');
      if (addCartButton) {
        event.preventDefault();
        handleAddCartButton(addCartButton);
        return;
      }

      var addAllButton = event.target.closest('[data-mublig-wishlist-add-all]');
      if (addAllButton) {
        event.preventDefault();
        handleAddAllButton(addAllButton);
        return;
      }

      var shareButton = event.target.closest('[data-mublig-wishlist-share]');
      if (shareButton) {
        event.preventDefault();
        handleShareButton(shareButton);
        return;
      }

      var removeButton = event.target.closest('[data-mublig-wishlist-remove]');
      if (removeButton) {
        event.preventDefault();
        removeItem(removeButton.dataset.mubligWishlistRemove);
      }
    });
  }

  function updateAll() {
    var list = getList();

    updateHeaderCount(list);
    updateButtons(list);
    updateWishlistPage(list);

    if (document.getElementById('MubligWishlistPage')) {
      refreshLiveWishlistItems(list);
    }

    document.dispatchEvent(new CustomEvent('mublig:wishlist:updated', {
      detail: {
        count: list.length,
        items: list
      }
    }));
  }

  function init() {
    mergeGuestIntoCustomerIfNeeded();
    bindClicks();

    importSharedWishlistFromUrl().then(function () {
      updateAll();
    });
  }

  window.MubligWishlist = {
    get: getList,
    count: countItems,
    add: addItem,
    remove: removeItem,
    toggle: toggleItem,
    has: hasItem,
    refresh: updateAll,
    refreshLive: refreshLiveWishlistItems,
    shareUrl: buildWishlistShareUrl
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', updateAll);
})();